import { render, staticRenderFns } from "./settingsApp.vue?vue&type=template&id=3bea1056&scoped=true&"
import script from "./settingsApp.vue?vue&type=script&lang=js&"
export * from "./settingsApp.vue?vue&type=script&lang=js&"
import style0 from "./settingsApp.vue?vue&type=style&index=0&id=3bea1056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea1056",
  null
  
)

export default component.exports